import React from "react";

export function BasicSpinner({ type = "border" }) {
  return (
    <div className={`spinner-${type}`} role="status">
      <span className="sr-only">Loading...</span>
    </div>
  );
}
